import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M13.046 1.126l2.823 5.738c.162.324.486.555.88.624l6.316.926c.948.139 1.319 1.296.648 1.967l-4.582 4.465c-.277.255-.393.648-.347 1.018l1.088 6.294c.162.948-.833 1.665-1.69 1.226l-5.645-2.985a1.134 1.134 0 00-1.087 0l-5.646 2.985c-.856.44-1.85-.278-1.689-1.226l1.088-6.294a1.152 1.152 0 00-.324-1.04L.298 10.38c-.695-.671-.301-1.828.647-1.967l6.317-.926c.37-.069.694-.3.88-.647l2.822-5.715c.416-.856 1.643-.856 2.082 0z" />,
  'Star'
)
